import axios from '@axios'
export const state = {
  routes: [],
  currentPage: 1,
  perPage: 15,
  totalPages: 1,
  totalRecords: 1,
}
export const getters = {
  allRoutes: (state) => state.routes,
  currentPage: (state) => state.currentPage,
  perPage: (state) => state.perPage,
  totalPages: (state) => state.totalPages,
  totalRecords: (state) => state.totalRecords,
}
export const mutations = {
  GET_ROUTES: (state, data) => {
    state.routes = data.routes
    state.totalPages = data.totalPages
    state.currentPage = data.page
    state.totalRecords = data.totalRecords
    state.perPage = data.perPage
  },
  CREATE_ROUTE: (state, routes) => {
    state.routes = [...routes, ...state.routes]
  },
  REMOVE_ROUTES: (state, routes) => {
    state.routes = state.routes.filter((rt) => rt.id !== routes.id)
  },
}
export const actions = {
  async getUserRoutes({ commit }, user = {}) {
    await axios.get(`/users/${user.id}/routes`).then((resp) => {
      if (resp.status === 200) {
        commit('GET_ROUTES', resp.data)
      }
    })
  },
  async importRoutes({ commit }, params) {
    await axios
      .post(`/users/${params.user.id}/routes`, { routes: params.routes })
      .then((resp) => {
        if (resp.status === 201) {
          commit('CREATE_ROUTE', resp.data.routes)
        }
      })
  },
  async removeRoute({ commit }, params) {
    await axios
      .delete(`/users/${params.user.id}/routes/${params.route.id}`)
      .then((resp) => {
        if (resp.status === 204) {
          commit('REMOVE_ROUTES', params.route)
        }
      })
  },
}
